export default "__VITE_ASSET__b16923d7__"